const getImageSize = (url: string,size:'180' | '450') => {
    if(!url) return ''
  const lastInd = url.lastIndexOf('.');
  const type={
    '180': url.slice(0,lastInd) + '_sharp180.' + url.slice(lastInd+1),
    '450': url.slice(0,lastInd) + '_sharp450.' + url.slice(lastInd+1),
  }
  return type[size]
};
export default getImageSize